import type { FunctionComponent } from 'react';

type SoftSkillIconProps = {
    readonly isActive: boolean;
};

export const SoftSkillIcon: FunctionComponent<SoftSkillIconProps> = ({ isActive }: SoftSkillIconProps) => {
    return (
        <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
            <circle cx="6" cy="6" fill={isActive ? '#FC531F' : '#1D272D'} r="5.25" />
        </svg>
    );
};
